<template>
    <div v-if="tbldata.length === 0" class="alert alert-success alert-dismissible fade show col-md-8" role="alert"
         style=" margin-left: 20%;">
        Δεν υπάρχουν ανακοινώσεις προς εμφάνιση.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div v-else class="container">
        <h2>{{ container_title }}</h2>
        <!--div v-if="role === 'ROLE_MANAGER' || role === 'ROLE_ADMIN'">
            <router-link class="btn btn-outline-primary" to="/create-announcement">Νέα Ανακοίνωση</router-link>
        </div-->
        <br> <br>

        <table class="table table-hover table-bordered" id="table" data-toggle="table">
            <thead>
            <tr>
                <th>
                    Κωδικός Ανακοίνωσης
                </th>
                <th>
                    Τίτλος Ανακοίνωσης
                </th>
                <th>
                    Μονάδα Επιστράτευσης
                </th>
                <th>
                    Ημερομηνία Δημοσίευσης
                </th>
                <th>
                    Κατάσταση
                </th>
                <th>
                    <!-- κουμπί επιλογής -->
                </th>
            </tr>
            </thead>

            <tbody>
            <tr id="sth" v-for="item in tbldata" :key="item.anakoinwshKwd">
                <td>{{ item.anakoinwshKwd }}</td>
                <td>{{ item.anakoinwshLek }}</td>
                <td v-if="$router.currentRoute.path === '/meannouncements'" id="mee-name">{{ item.moepLek }}</td>
                <td v-else-if="$router.currentRoute.path === '/depsannouncements'" id="deps-name">{{ item.sxhmatismosLek }}</td>
                <td v-else id="monada"></td>
                <td id="username">{{ formatDate(item.anakoinwshDate) }}</td>
                <td><p v-if="item.anakoinwshStatus==='PENDING'" style="color: orange;" class="card-text">
                    {{ convertAnakoikwsiLekToGreekLek(item.anakoinwshStatus) }}</p>
                    <p v-else class="card-text">{{ convertAnakoikwsiLekToGreekLek(item.anakoinwshStatus) }}</p>
                </td>
                <td>
                    <div>
                        <router-link type="button" class="btn btn-outline-primary"
                                     :to="{name:'view_me_announcement', params:{ id: item.anakoinwshKwd}}">
                            Εμφάνιση
                        </router-link>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "Announcements",
    data: function () {
        return {
            tbldata: [],
            moepKwd: "",
            role: '',
            container_title: '',
            api_url: '',
        };
    },
    created() {
        if (!this.$store.getters.getToken) this.$router.push('login');
    },
    mounted() {
        this.getAnnouncements();
        console.log(this.$router.currentRoute.path);
    },
    watch: {
        '$route': 'getAnnouncements'
    },
    methods: {
        convertAnakoikwsiLekToGreekLek: function (text) {
            let arr = [];
            arr["PUBLISHED"] = 'Δημοσιευμένη';
            arr["PENDING"] = 'Προς έγκριση';

            return arr[text] ? arr[text] : text;
        },
        initViewData: function () {
            this.tbldata = [];
            this.role = this.$store.getters.userRole;
            this.container_title = 'Εμφάνιση Ανακοινώσεων ΜΕ';
            if (this.$router.currentRoute.path === '/meannouncements') {
                this.api_url = '/announcements/units';
                if (this.role === "ROLE_MANAGER") {
                    this.api_url += '/' + this.$store.getters.meeResponsible;
                } else if (this.role === 'ROLE_USER') {
                    this.api_url = '/announcements/mee/user/' + this.$store.getters.mebelongs;
                    this.api_url += '?status=PUBLISHED';
                } else if (this.role === "ROLE_SXHMATISMOS") {
                    this.api_url += '/deps/' + this.$store.getters.meeResponsible;
                }
            } else if (this.$router.currentRoute.path === '/depsannouncements') {
                this.container_title = 'Εμφάνιση Ανακοινώσεων ΔΕΠΣ';
                if (this.role === "ROLE_SXHMATISMOS") {

                    this.api_url = '/announcements/deps';
                } else if (this.role === 'ROLE_USER') {

                    this.api_url = '/announcements/deps/user/' + this.$store.getters.mebelongs;
                } else if (this.role === "ROLE_ADMIN" || this.role === "ROLE_SUPERADMIN") {
                    this.api_url = '/announcements/deps';
                }
            } else if (this.$router.currentRoute.path === '/desannouncements') {
                this.container_title = 'Εμφάνιση Ανακοινώσεων ΓΕΣ/Α4 (ΔΕΠΕΘ)';
                this.api_url = '/announcements/des';
            } else if (this.$router.currentRoute.path === '/omadesannouncements' && this.role === 'ROLE_USER') {
                this.container_title = 'Εμφάνιση Ανακοινώσεων Ομάδων';
                this.api_url = '/announcements/omades';
            } else if (this.$router.currentRoute.path === '/announcements' && this.role === 'ROLE_USER') {
                this.container_title = 'Εμφάνιση Ανακοινώσεων';
                this.api_url = `/announcements/user/${this.$store.getters.mebelongs}`;
            }
        },

        getAnnouncements: function () {
            this.initViewData();
            this.$store.dispatch('loading');
            this.$http.get(this.api_url)
                .then((response) => {
                    let resp = response.data;
                    this.tbldata = resp.responseData;
                    this.tbldata.sort((a,b) => a.anakoinwshKwd > b.anakoinwshKwd ? 1 : -1)
                })
                .finally(() => this.$store.dispatch('stop_loading'));
        },

        formatDate: function (date) {
            return date.split("T")[0].split("-").reverse().join("/");
        }
    }
}
</script>